import A11yDialog from 'a11y-dialog';

export default function singleProductModal () {
  const $ = jQuery;

  // Get the dialog element
  const el = $( '#product-review-modal' )[0];

  if ( ! el ) {
    return;
  }

  // Instantiate a new A11yDialog module
  const dialog = new A11yDialog( el );

  const $commentTextArea = $( '#comment' );
  const $authorInput     = $( '#author' );
  const $emailInput      = $( '#email' );

  $authorInput.attr( 'placeholder', 'Name' );
  $emailInput.attr( 'placeholder', 'Email' );
  $commentTextArea.attr( 'placeholder', 'Your Review' );
}
